import { isEmpty } from 'lodash'
import { TRoleAssignmentWithAssociatedRole } from 'types/accounts'
import { TOptionSelectDropdown } from 'types/components'
import { filterRolesByAppTypeAndName } from './filterRolesByAppTypeAndName'

// This func is used to filter roleAssignments with nested userRoles, where userRoles have
// special requirments to be displayed as defaultOption: appType === null and name shouldn't include
// word "Oz"

export const transformRoleAssignmentsToDefaultOptionRoles = (
  roleAssignments: TRoleAssignmentWithAssociatedRole[],
  venueUuid: string
): TOptionSelectDropdown => {
  // check if role assignment is matching with venue
  const roleAssignmentsMatchedWithVenue: TRoleAssignmentWithAssociatedRole[] =
    roleAssignments?.filter((roleAssignment) => roleAssignment?.venueId === venueUuid)

  // check if userRole assigned to roleAssigment have appType === null && name doesnt contain 'Oz'
  const filteredUserRolesInRoleAssignment = roleAssignmentsMatchedWithVenue?.reduce(
    (
      acc: TRoleAssignmentWithAssociatedRole[],
      cur: TRoleAssignmentWithAssociatedRole
    ): TRoleAssignmentWithAssociatedRole[] => {
      const filteredRoles = filterRolesByAppTypeAndName(cur.userRoles)
      if (isEmpty(filteredRoles)) {
        return [...acc]
      } else {
        return [{ ...acc, ...cur, userRoles: filteredRoles }]
      }
    },
    []
  )

  // transform roles to format expected by selectDropdown
  const transformedRoles = filteredUserRolesInRoleAssignment?.reduce(
    (_, roleAssignment: TRoleAssignmentWithAssociatedRole): TOptionSelectDropdown => {
      const role = roleAssignment.userRoles?.map((role) => {
        return {
          name: role.name ?? '',
          uuid: role.uuid ?? '',
        }
      })

      return role[0]
    },
    { name: 'unknown', uuid: '' }
  )

  return transformedRoles
}
